import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'

export default function SurveyDateIcon({ color = '#9E9E9E' }) {
  return (
    <CalendarTodayOutlinedIcon
      sx={{
        fontSize: 18,
        color,
        flexShrink: 0
      }}
    />
  )
}
